import { render, staticRenderFns } from "./flex-1.vue?vue&type=template&id=598980c4&scoped=true&"
import script from "./flex-1.vue?vue&type=script&lang=js&"
export * from "./flex-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598980c4",
  null
  
)

export default component.exports